import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ThumbsUpIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M4.497 8.918c1.132 0 1.997.904 1.997 2.086v8.902c0 1.182-.865 2.086-1.997 2.086S2.5 21.088 2.5 19.906v-8.902c0-1.182.865-2.086 1.997-2.086Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M4.525 22h11.772c1.621 0 3.031-1.059 3.243-2.54l1.832-7.085c.635-2.612-1.198-3.529-3.242-3.529h-3.51a.297.297 0 0 1-.275-.41C15.775 4.634 14.408 2 12.985 2c-1.425 0-1.27 1.906-2.116 3.811-1.41 3.106-3.242 3.106-3.665 3.106H4.525"
        />
      </svg>
    </Icon>
  )
}
export default ThumbsUpIcon
